import Button from "./Button";

export default function PrimaryButton(props) {
	return <Button primary {...props} />;
}
